'use strict';
var i18n = require('shared/scripts/modules/utils/i18n');

var options = {
    ns: ['intl', 'common'],
    defaultNS: 'intl',
    backend: {
        loadPath: process.env.contextRoot + '/locales/{{lng}}/{{ns}}.json'
    },
};

var initialized;

function init() {
    if (initialized === undefined) {
        initialized = i18n.doSetup(options);
    }
    return initialized;
}

module.exports = {
    init: init,
    translate: i18n.translate
};



//////////////////
// WEBPACK FOOTER
// ./src/international/scripts/utils/i18n.js
// module id = IlWE
// module chunks = 0 1 2 3 4 5 6 7 8